
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/level-2-electrical-services-asp-accredited-sydney/electrical-private-power-pole-installations",
      function () {
        return require("private-next-pages/services/level-2-electrical-services-asp-accredited-sydney/electrical-private-power-pole-installations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/level-2-electrical-services-asp-accredited-sydney/electrical-private-power-pole-installations"])
      });
    }
  